/**
 *  the factory for drawings context menu
 */
import * as L from "leaflet";
import {mapContext} from "@/context/global.js";
import {copyToClipboard} from "@/engine/helpers/clipboard.js";
import {toDMS} from "@/engine/helpers/coordinates.js";

export function CreateDrawingContextMenu(leafletLayer) {
    let ll = leafletLayer;
    let vl = ll._maphubVectorLayer;

    const CMI_COORDINATES = 1;
    const CMI_COORDINATES_DMS = 2;
    const CMI_PROPERTIES_SEPARATOR = 3;
    const CMI_RENAME = 4;
    const CMI_SHOWLABEL = 5;
    const CMI_SHOWAREA = 7;
    const CMI_SHOWSEGMENTSLENGTH = 9;
    const CMI_SHOWTOTALLENGTH = 10;
    const CMI_STYLE = 12;
    const CMI_DELETE = 15;
    const CMI_EXPORT = 20;


    let leafletLayerOptions = {
        contextmenu: true,
    };

    // get marker coordinates or geometry center coordinates
    let coordinates = (typeof ll.getLatLng === "function") ? ll.getLatLng() : ll.getBounds().getCenter();

    let editGeometryLabel = function (ev, succCb) {
        mapContext.mapUI.createEditGeometryPropertiesWindowDialog(ll, function (prop) {
            if (ll instanceof L.Marker) {
                vl.UpdateMarkerTooltip(ll);
            } else if (typeof ll.labelRefresh === "function") {
                ll.labelRefresh();
            }
            vl.saveFeature(ll);
        }, succCb)
    }

    let showHideGeometryLabel = function (show) {
        if (ll.isLabelEnabled) {
            if (show === undefined) {
                ll.isLabelEnabled() ? ll.hideLabel() : ll.showLabel();
            } else {
                show ? ll.showLabel() : ll.hideLabel()
            }
        } else if (ll instanceof L.Marker){
            if (show === undefined) {
                ll.options.display.label = ! ll.options.display.label
            } else {
                ll.options.display.label = show
            }
            vl.UpdateMarkerTooltip(ll)
        }

        vl.saveFeature(ll)
    }

    leafletLayerOptions.contextmenuItems = []
    if (ll instanceof L.Circle || ll instanceof L.Marker) {
        leafletLayerOptions.contextmenuItems.push({
            // todo coordinates isn't updated on object drag
            text: "<span class=\"fa fa-crosshairs\"></span>&nbsp;&nbsp;" + coordinates.lat.toFixed(5) + ',' + coordinates.lng.toFixed(5),
            index: CMI_COORDINATES,
            callback: function(ev) {
                if (ll.getLatLng !== undefined) {
                    let msg = ll.getLatLng().lat + ',' + ll.getLatLng().lng
                    if (ll.getRadius !== undefined) {
                        msg += ',' + ll.getRadius().toFixed(0) + 'm'
                    }
                    copyToClipboard(msg, "COORDINATES");
                }
            },
        },{
            // todo coordinates isn't updated on object drag
            text: toDMS(coordinates.lat, coordinates.lng, 2),
            index: CMI_COORDINATES_DMS,
            callback: function(ev) {
                if (ll.getLatLng !== undefined) {
                    let msg = toDMS(ll.getLatLng().lat, ll.getLatLng().lng, 4)
                    if (ll.getRadius !== undefined) {
                        msg += ',' + ll.getRadius().toFixed(0) + 'm'
                    }
                    copyToClipboard(msg, "COORDINATES");
                }
            },
        },{
            separator: true,
            index: CMI_PROPERTIES_SEPARATOR
        })
    }

    if (vl.workspace.writable) {
        leafletLayerOptions.contextmenuItems.push({
            text: 'Edit label...',
            callback: editGeometryLabel.bind(this),
            index: CMI_RENAME
        });

        leafletLayerOptions.contextmenuItems.push({
            text: 'Show/hide label',
            callback: function(ev) {
                let descr = ll.getProperty("descr");
                if (descr === undefined || descr === "") {
                    editGeometryLabel(ev, function () {
                        showHideGeometryLabel(true)
                    })
                } else {
                    showHideGeometryLabel()
                }
            },
            index: CMI_SHOWLABEL
        });

        if (ll instanceof L.Circle || ll instanceof L.Polygon) {
            leafletLayerOptions.contextmenuItems.push({
                text: 'Show/hide area',
                callback: function(ev) {
                    ll.isAreaEnabled() ? ll.hideArea() : ll.showArea();
                    vl.saveFeature(ll)
                },
                index: CMI_SHOWAREA
            });
        }

        if (ll instanceof L.Polyline) {
            leafletLayerOptions.contextmenuItems.push({
                text: 'Show/hide segments length',
                callback: function(ev) {
                    ll.isLengthSegmentEnabled() ? ll.hideLengthSegment() : ll.showLengthSegment();
                    vl.saveFeature(ll)
                }.bind(this),
                index: CMI_SHOWSEGMENTSLENGTH
            });
        }

        if (ll instanceof L.Polyline && ! (ll instanceof L.Polygon)) {
            leafletLayerOptions.contextmenuItems.push({
                text: 'Show/hide length',
                callback: function(ev) {
                    ll.isLengthTotalEnabled() ? ll.hideLengthTotal() : ll.showLengthTotal();
                    vl.saveFeature(ll)
                },
                index: CMI_SHOWTOTALLENGTH
            });
        }

        if (! (ll instanceof L.Marker)) {
            leafletLayerOptions.contextmenuItems.push({
                text: 'Change style...',
                callback: function(ev) {
                    mapContext.mapUI.styleEditor.initChangeStyle(ll);
                },
                index: CMI_STYLE
            });
        }

        if (ll instanceof L.Polyline) {
            leafletLayerOptions.contextmenuItems.push({
                text: 'Export as...',
                callback: function(ev) {
                    mapContext.pdf.setMaxZoom(vl.workspace.getMaxZoom())
                    mapContext.mapUI.createGeometryExportDialog(ll)
                },
                index: CMI_EXPORT
            });
        }

    }

    ll.bindContextMenu(leafletLayerOptions)
}
